import axios from 'axios'
import { ecboClient, getHeaderLocale } from 'lib/axios'
import { setupCache } from 'axios-cache-interceptor'

import type { PrefecturesResponse } from 'features/prefecture/types/prefecture'
import { JP_COUNTRY_ID } from 'features/prefecture/constants'

const API_PREFECTURES = '/api/web/prefectures'
export const PREFECTURE_AREAS_CACHE_TTL = 24 * 60 * 60 * 1000

// Dedicated instance so setupCache does not affect shared ecboClient GETs (e.g. available_items).
const cachedPrefectureAreasClient = setupCache(axios.create(ecboClient.defaults), {
  interpretHeader: false,
})

type FetchPrefectureAreasParams = {
  locale: string
  countryId?: number
}

export const getPrefectureAreasCacheId = (acceptLanguage: string, countryId: number): string =>
  `prefecture-areas:${acceptLanguage}:${countryId}`

export const fetchPrefectureAreas = async ({
  locale,
  countryId = JP_COUNTRY_ID,
}: FetchPrefectureAreasParams) => {
  const acceptLanguage = getHeaderLocale(locale)
  const response = await cachedPrefectureAreasClient.get<PrefecturesResponse>(API_PREFECTURES, {
    params: { country_id: countryId },
    headers: { 'Accept-Language': acceptLanguage },
    id: getPrefectureAreasCacheId(acceptLanguage, countryId),
    cache: {
      ttl: PREFECTURE_AREAS_CACHE_TTL,
    },
  })
  return {
    isOk: true as const,
    data: response.data,
  }
}
